import React, { Component } from 'react';
import { DomCustomImage, DomField, ErrorMsg, DomTextarea, DomCheckboxField } from "../Services/formDOM.jsx"
import { hasValue, returnValue, validateEmail } from "../Services/formHandlers"
import { apiURL } from "../Services/baseURL"
import { push } from "../Services/Analytics"
import "./Form.scss"
import Loading from '../Services/Loading/Loading';

class Form extends Component {
    constructor() {
        super();
        this.handleInputChange = this.handleInputChange.bind(this);
        this.setErrorMessage = this.setErrorMessage.bind(this);
        this.checkInput = this.checkInput.bind(this);
        this.addState = this.addState.bind(this);
        this.sendForm = this.sendForm.bind(this);
        this.state = {
            Takanon: {
                name: "Takanon",
                value: 0
            },
            isLoading: false,
            busy: false
        }
    }
    componentDidMount() {
        this.addState("FullName");
        this.addState("Email");
        this.addState("Phone");
    }
    addState(stateName) {
        this.setState({
            [stateName]: {
                name: stateName,
                value: null
            }
        })
    }
    handleInputChange(event) {
        this.setState({
            [event.target.name]: {
                name: event.target.name,
                value: event.target.value
            }
        })
        if (event.target.name == "Takanon") {
            this.setState({
                Takanon: {
                    name: event.target.name,
                    value: (this.state[event.target.name].value ? 0 : 1),
                }
            })
        }
    }
    setErrorMessage(target, msg) {
        if (this.state[target.name]) {
            this.setState({
                [target.name]: {
                    name: target.name,
                    value: target.value,
                    error: msg
                }
            })
        }
    }
    checkInput(state) {
        var error = "שדה חובה";
        const errors = {
            FullName: "שם מלא לא תקין",
            Email: "דוא\"ל לא תקין",
            Phone: "מספר הטלפון לא תקין",
        }
        if (!hasValue(state)) {
            this.setErrorMessage(state, errors[state.name]);
            return false;
        }
        switch (state.name) {
            case "FullName":
                if (state.value.length < 2) {
                    this.setErrorMessage(state, errors[state.name]);
                    return false;
                }
                break;
            case "Phone":
                if (state.value.length < 7 || state.value.length > 15) {
                    this.setErrorMessage(state, errors[state.name]);
                    return false;
                }
                break;
            case "Email":
                if (!validateEmail(state.value)) {
                    return false;
                }
                break;
            case "Takanon":
                if (state.value != 1) {
                    alert("כדי להמשיך יש להסכים לתקנון");
                    return false;
                }
                break;
        }
        return true;
    }
    sendForm() {
        const state = this.state;
        var error = false;

        if (!this.checkInput(state.FullName)) {
            error = true;
        }
        if (!this.checkInput(state.Phone)) {
            error = true;
        }
        if (!this.checkInput(state.Email)) {
            error = true;
        }
        if (error) {
            return;
        }
        if (!state.busy) {
            this.setState({
                busy: true,
                isLoading: true
            })
            fetch(`${apiURL}save`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    FullName: returnValue(state.FullName),
                    Phone: returnValue(state.Phone),
                    Email: returnValue(state.Email),
                    AcceptedTOS: returnValue(state.Takanon),
                    LeadProjectID: 1
                })
            }).then(data => {
                push("Form_Sent", "");
                this.setState({
                    busy: false,
                    isLoading: false,
                    FullName: {
                        name: "FullName",
                        value: " ",
                        error: null
                    },
                    Email: {
                        name: "Email",
                        value: " ",
                        error: null
                    },
                    Phone: {
                        name: "Phone",
                        value: " ",
                        error: null
                    },
                    Takanon: {
                        name: "Takanon",
                        value: 0
                    }
                })
                this.props.triggerPopup();
            });
        }
    }
    render() {
        return (
            <section className="section section-formlead">
                <a name="hearmore"></a>
                <Loading showLoading={this.state.isLoading} />
                <div className="padding">
                    <div className="container">
                        <div className="headline">
                            <div className="head1"></div>
                            <div className="head2"></div>
                        </div>
                        <div className="form">
                            <DomField type="text" placeholder="שם מלא" name="FullName" id="FullName" onChange={this.handleInputChange} {...this.state} />
                            <DomField type="tel" placeholder="טלפון" name="Phone" id="Phone" onChange={this.handleInputChange} {...this.state} />
                            <DomField type="email" placeholder="דוא&quot;ל" name="Email" id="Email" onChange={this.handleInputChange} {...this.state} />
                            <DomCheckboxField type="checkbox" name="Takanon" id="Takanon" onChange={this.handleInputChange} {...this.state} />
                        </div>
                        <div className="footer">
                            <div className="sendbutton" onClick={this.sendForm}></div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default Form;



// WEBPACK FOOTER //
// ./src/Components/Form/Form.jsx